import {
    StickerList,
    NameFontDataMap,
    NO_STICKER,
    AUTO_FONT,
} from '../../model';
import { CloseCircleOutlined } from '@ant-design/icons';

export const getNameFontOptionList = (dictionary: Record<string, string>) => [
    { label: dictionary['input.name-style.type.auto.label'], value: AUTO_FONT },
    ...Object.values(NameFontDataMap).map(({ value, labelKey }) => ({
        label: dictionary[labelKey],
        value,
    })),
];

export const StickerButtonList = StickerList.map(({ value }) => ({
    label: value === NO_STICKER
        ? <CloseCircleOutlined />
        : <img alt={value} src={`${process.env.PUBLIC_URL}/asset/image/sticker/sticker-${value.toLowerCase()}.png`} />,
    value,
}));
